import { type ReactElement, cloneElement, useContext } from 'react'

import { TapTip } from '@/components/ui/tooltip'

import { SetupContext } from './context'

export const STAFF_WRITE_BLOCKED_REASON =
  'You are signed in as TandemOne staff. Staff can browse and fill out this form in production, but not submit it. Use stage to test the flow.'

export function StaffWriteGate({
  children
}: {
  children: ReactElement<{ disabled?: boolean }>
}) {
  const blocked = useContext(SetupContext)?.setupState?.staffWritesBlocked

  if (!blocked) return children

  return (
    <TapTip content={STAFF_WRITE_BLOCKED_REASON}>
      <span className='inline-flex'>
        {cloneElement(children, { disabled: true })}
      </span>
    </TapTip>
  )
}
